import { Converter, ObjectDataset } from "@tblabs/storage";
import { Collection, RefBool, RefString } from "@tblabs/truffle";
import { v4 as uuidv4 } from 'uuid';
import { RawAgent } from "./RawAgent";

export class Agent
{
    public Id = "";
    public IsActive = new RefBool();
    public Icon = new RefString();
    public Name = new RefString();
    public Phone = new RefString();

    public get AsString(): string
    {
        return this.Icon.value + " " + this.Name.value;
    }

    constructor(raw: RawAgent)
    {
        this.Id = raw.Id;
        this.IsActive.value = raw.IsActive;
        this.Icon.value = raw.Icon;
        this.Name.value = raw.Name;
        this.Phone.value = raw.Phone;
    }

    public ToRaw(): RawAgent
    {
        return { Id: this.Id, IsActive: this.IsActive.value, Icon: this.Icon.value, Name: this.Name.value, Phone: this.Phone.value };
    }

    public static get Default(): Agent
    {
        return new Agent({ Id: "tB", Icon: "🐓", Name: "Tomasz", Phone: "507-293-714", IsActive: true });
    }
}


export class AgentsConverter extends Converter<RawAgent, Agent>
{
    protected ConvertToRaw(raw: Agent): RawAgent
    {
        return raw.ToRaw();
    }
    protected ConvertFromRaw(raw: RawAgent): Agent
    {
        return new Agent(raw);
    }
}

export class AgentsProvider
{
    private agents = new Collection<Agent>([Agent.Default]);

    constructor(private _repo: ObjectDataset<Agent>)
    { }

    public async Init(): Promise<void>
    {
        try
        {
            const agents = await this._repo.GetAll();
            this.agents.Add(...agents);
        }
        catch (ex: any)
        {
            console.warn("Could not load agents: ", ex.message);
        }
    }

    public get All(): Collection<Agent>
    {
        return this.agents;
    }

    public Get(id: string): Agent | undefined
    {
        return this.agents.Find(x => x.Id === id);
    }

    public async Add(): Promise<void>
    {
        const id = uuidv4();
        const agent = new Agent({ Id: id, Icon: "😉", Name: "Nowy agent", Phone: "", IsActive: true });
        this.agents.Add(agent);
        await this._repo.Add(id, agent);
    }

    public async Save(x: Agent): Promise<void>
    {
        await this._repo.Update(x.Id, x);
    }
}
